function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9312 5.40084C15.7953 5.41881 15.6695 5.48287 15.575 5.58209C15.3398 5.81725 13.5188 7.68829 11.6688 9.58829C9.993 11.3094 8.57197 12.7711 8.14377 13.2071L4.36257 10.3259C4.23601 10.2275 4.07507 10.1837 3.91569 10.2048C3.7571 10.2251 3.61257 10.3095 3.51569 10.4368C3.41882 10.565 3.37741 10.7267 3.40007 10.8853C3.42273 11.0439 3.50867 11.1868 3.63757 11.2822L7.83757 14.4822C8.07741 14.6634 8.41335 14.6392 8.62507 14.4259C8.86023 14.1907 10.6813 12.3259 12.5313 10.4259C14.3813 8.5259 16.2603 6.5907 16.4251 6.4259C16.6094 6.24622 16.6587 5.96808 16.5469 5.73606C16.4352 5.50402 16.1868 5.36888 15.9313 5.4009L15.9312 5.40084Z",
  fill: "#9F5F39"
});

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.e62d27d9.svg";
export { ForwardRef as ReactComponent };